import styled from "styled-components";

// tslint:disable-next-line
export const LastOpenedSystemsContainerMetaElement = styled.div`
  p {
    font-size: 12px;
    margin: 5px 0;
  }
`;
